import { DART_MARK_K, dartCentred, dartIcon } from '../brand/art.ts';

const INNER = dartCentred('currentColor', DART_MARK_K);

/**
 * The Sparrow brand mark: the Dart, a sparrow diving ↘ (docs/mockups/sparrow.html, B).
 * It leads the "sparrow" wordmark everywhere the brand shows (the brand row, the game's
 * masthead, the DONE. poster, the loading and error lockups, the challenge landing).
 * Inherits `currentColor` (vermilion in the wordmark). Decorative: the wordmark beside
 * it carries the name.
 */
export function DartMark({ className, size }: { className?: string; size?: number }) {
	return (
		<svg
			className={className}
			viewBox="0 0 100 100"
			width={size}
			height={size}
			aria-hidden="true"
			focusable="false"
			dangerouslySetInnerHTML={{ __html: INNER }}
		/>
	);
}

const TILE = dartIcon().replace(/^<svg[^>]*>/, '').replace(/<\/svg>$/, '');

/**
 * The home-screen tile itself (the app icon: the ink Dart on vermilion), drawn small
 * where the install line offers it ("this is what you'd get"). Decorative.
 */
export function DartTile({ className }: { className?: string }) {
	return <svg className={className} viewBox="0 0 100 100" aria-hidden="true" focusable="false" dangerouslySetInnerHTML={{ __html: TILE }} />;
}
